export const BREAKPOINTS = {
  mobile: 480,
  tablet: 768,
  desktop: 1024,
  large: 1440,
  wide: 1920,
  ultraWide: 2560,
} as const;

// Consistent helper functions for JavaScript logic
export const isAtMostMobile = (width: number): boolean =>
  width <= BREAKPOINTS.mobile;
export const isAtMostTablet = (width: number): boolean =>
  width <= BREAKPOINTS.tablet;
export const isAtMostDesktop = (width: number): boolean =>
  width <= BREAKPOINTS.desktop;
export const isAtMostLarge = (width: number): boolean =>
  width <= BREAKPOINTS.large;
export const isAtMostWide = (width: number): boolean =>
  width <= BREAKPOINTS.wide;

// CSS media query strings (fixes the 768px gap by using tablet + 1 for min-width)
export const MEDIA_QUERIES = {
  mobile: `@media (max-width: ${BREAKPOINTS.mobile}px)`,
  tablet: `@media (max-width: ${BREAKPOINTS.tablet}px)`,
  desktop: `@media (max-width: ${BREAKPOINTS.desktop}px)`,
  large: `@media (max-width: ${BREAKPOINTS.large}px)`,
  wide: `@media (max-width: ${BREAKPOINTS.wide}px)`,
  aboveTablet: `@media (min-width: ${BREAKPOINTS.tablet + 1}px)`,
  aboveDesktop: `@media (min-width: ${BREAKPOINTS.desktop + 1}px)`,
  aboveLarge: `@media (min-width: ${BREAKPOINTS.large + 1}px)`,
  aboveWide: `@media (min-width: ${BREAKPOINTS.wide + 1}px)`,
} as const;

// Export types for type safety
export type Breakpoint = keyof typeof BREAKPOINTS;
